export default "__VITE_ASSET__mgNdD0$B__"